import React, {Component} from 'react';
import '../css/exhibition.css'
import {Link} from 'react-router';


class Table extends Component {
    state = {
     open: false,
   };

   handleOpen = (imgObj) => {
     this.setState({
       url: imgObj.full_img_url,
       open: true
     });
   };

   handleClose = () => {
     this.setState({
       open: false
     });
   };

    render() {
        return (
            <div>
                <table>
                      <ConstructTable {...this.props} />
                </table>
            </div>
        )
    }
};

class ConstructTable extends Component {
    render() {
        return (
            <tbody>
                    <tr>
                        <Col artwork={this.props.array[0]} index={this.props.index} />
                        <Col artwork={this.props.array[1]} index={this.props.index}/>
                        <Col artwork={this.props.array[2]} index={this.props.index}/>
                    </tr>
                    <tr>
                        <Col artwork={this.props.array[3]} index={this.props.index}/>
                        <Col artwork={this.props.array[4]} index={this.props.index}/>
                        <Col artwork={this.props.array[5]} index={this.props.index}/>
                    </tr>
            </tbody>
        )
    }
};

class Col extends Component {
  render() {
    var painting_oid = this.props.artwork.painting_oid.split(',');
    var fname = this.props.artwork.paintings.split(',');
    if (this.props.artwork.artwork_name) {
      return (
      <td>
        <Link to={'/art/'+this.props.artwork.exhibition_name+'/'+this.props.artwork.artwork_url+'?id='+this.props.index} >
            <figure className="image-container" style={{
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${'/api/viewimage/'+painting_oid[0]+'/s=350/'+fname[0]})`
              }}>
                <figcaption>
                    <div>
                        <p>
                            {this.props.artwork.artwork_name}
                        </p>
                    </div>
                </figcaption>
            </figure>
        </Link>
      </td>)
    } else {
      return <td></td>
    }
  }
}
export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.jsx